import * as Sentry from '@sentry/vue';
import { app } from '@store/modules/app';
import { Toast } from 'types/layout';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorHandler(err: any): Promise<unknown> {
	const errorToast: Toast = err?.config?.errorToast ?? {
		type: 'error',
		message:
			'An error has occurred. The error has been logged and we&rsquo;ll look into it immediately. If you need assistance, contact us at&nbsp;<a href="mailto:support@fundrise.com">support@fundrise.com</a>.'
	};

	if (
		(!err.response || (err.response?.status !== 401 && !err.response?.data?.fieldErrorMap)) &&
		!(err.config?.suppressToast && err.config?.suppressToast(err.response))
	) {
		app.ADD_TOAST(errorToast);
		if (typeof err === 'string') {
			Sentry.captureMessage(err);
		} else if (typeof err === 'object') {
			Sentry.setExtra('Response data', err?.response?.data);
			Sentry.captureException(err);
		}
	}

	return Promise.reject(err);
}
